export default __webpack_public_path__ + "static/media/screenShots_poland-1.8e7d06b4.jpg";